module.exports = __webpack_public_path__ + "assets/img/logo_for_service.4cfbec63.png";